import React, { Suspense } from 'react'
import MomentClient from './MomentClient'

export default function MomentFormatter(props) {
  const { date, className } = props
  return (
    <>
      <Suspense>
        <MomentClient date={date} className={className} />
      </Suspense>
    </>
  )
}
